import styled from 'styled-components';

const ContentScreen = styled.div`
   padding: 0 1em 1em;
   width: var(--safe-width);
   max-width: 1200px;
   margin: 0 auto;
   overflow: hidden;
   font-family: var(--content-font);

   &.narrower {
      max-width: 650px;
   }

   &.narrow {
      max-width: 900px;
   }

   &.wide {
      max-width: 1440px;
   }

   h1,
   h2,
   h3,
   h4,
   h5,
   h6 {
      font-family: var(--heading-font);
      margin-bottom: 1em;
      line-height: 1.3;
   }

   h1 {
      margin-top: 0.5em;
      font-size: 2em;
   }

   h2 {
      font-size: 1.5em;
   }

   h3 {
      font-size: 1.25em;
   }

   p {
      font-size: 1.125em;
      line-height: 1.2;
   }

   strong {
      font-weight: bold;
   }

   article {
      p {
         line-height: 1.6;
         margin-bottom: 1em;
      }
   }

   .content-styled-list {
      font-size: 1.125em;
      line-height: 1.6;
      margin-bottom: 1em;

      .button-link {
         text-decoration: none;
      }
      .button-link:hover,
      .button-link:focus-visible {
         text-decoration: underline;
      }

      .emoji {
         display: inline-block;
         width: 1.5em;
         text-align: left;
      }
   }

   @media (min-width: 400px) {
      padding: 0 2em 2em;
   }

   @media (min-width: 350px) {
      h1 {
         font-size: 2.5em;
      }

      h2 {
         font-size: 1.75em;
      }

      h3 {
         font-size: 1.33em;
      }

      p,
      .content-styled-list {
         font-size: 1.25em;
      }
   }

   @media (min-width: 500px) {
      h1 {
         font-size: 3em;
      }

      h2 {
         font-size: 2em;
      }

      h3 {
         font-size: 1.5em;
      }
   }

   @media (min-width: 850px) {
      padding: 0 3em 3em;
   }

   .link {
      color: var(--brand-darker-green);
      -webkit-text-decoration: underline;
      text-decoration: underline;
   }
   .link:hover,
   .link:focus-visible {
      -webkit-text-decoration: none;
      text-decoration: none;
   }

   @media (prefers-color-scheme: dark) {
      .link {
         color: #ff6912;
      }
   }
`;

export { ContentScreen };
